import React, { Suspense, lazy } from 'react';
import Transfers from './pages/Transfers';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { FinanceProvider } from './context/FinanceContext';
import { GLAccountProvider } from './context/GLAccountContext';
import { TransactionRuleProvider } from './context/TransactionRuleContext';
import { AuthProvider } from './context/AuthContext';
import { OrganizationProvider } from './context/OrganizationContext';
import { ErrorBoundary, LoadingContainer } from './components/common';
import { ProtectedRoute } from './components/common/ProtectedRoute';
import Layout from './components/layout/Layout';
// Import global styles
import './index.css';
import './styles.css';

// Lazy load components to reduce initial bundle size
const Dashboard = lazy(() => import('./components/dashboard/Dashboard'));
const Transactions = lazy(() => import('./components/transactions/Transactions'));
const GLAccounts = lazy(() => import('./components/gl/GLAccounts'));
const Rules = lazy(() => import('./pages/Rules'));
const AccountReconciliation = lazy(() => import('./pages/AccountReconciliation'));

const Settings = lazy(() => import('./components/settings/Settings'));

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <AuthProvider>
          <OrganizationProvider>
            <ProtectedRoute>
              <FinanceProvider>
                <GLAccountProvider>
                  <TransactionRuleProvider>
                <Routes>
                <Route path="/" element={<Layout />}>
              <Route index element={
                <Suspense fallback={<LoadingContainer text="Loading Dashboard..." />}>
                  <Dashboard />
                </Suspense>
              } />
              <Route path="transactions" element={
                <Suspense fallback={<LoadingContainer text="Loading Transactions..." />}>
                  <Transactions />
                </Suspense>
              } />
              <Route path="accounts" element={
                <Suspense fallback={<LoadingContainer text="Loading GL Accounts..." />}>
                  <GLAccounts />
                </Suspense>
              } />
              <Route path="transfers" element={
                <Suspense fallback={<LoadingContainer text="Loading Transfers..." />}>
                  <Transfers />
                </Suspense>
              } />
              <Route path="rules" element={
                <Suspense fallback={<LoadingContainer text="Loading Rules..." />}>
                  <Rules />
                </Suspense>
              } />
              <Route path="reconciliation" element={
                <Suspense fallback={<LoadingContainer text="Loading Account Reconciliation..." />}>
                  <AccountReconciliation />
                </Suspense>
              } />
              <Route path="reports" element={<div className="p-4">Reports page (coming soon)</div>} />
              <Route path="settings" element={
                <Suspense fallback={<LoadingContainer text="Loading Settings..." />}>
                  <Settings />
                </Suspense>
              } />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
          </Routes>
                  </TransactionRuleProvider>
                </GLAccountProvider>
              </FinanceProvider>
            </ProtectedRoute>
          </OrganizationProvider>
        </AuthProvider>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
